// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-71a91fa6] .readonly-field-label {\r\n  font-size: 0.65rem !important;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05rem;\r\n  color: #78909C !important; /* Muted blue-grey */\r\n  margin-bottom: 2px;\n}\n[data-v-71a91fa6] .readonly-field-value {\r\n  font-size: 0.9rem !important;\r\n  color: #263238 !important; /* High contrast dark */\r\n  font-weight: 600;\n}\r\n", ""]);
// Exports
module.exports = exports;
